import { featureFlags } from './featureFlags';

export type ReviewSource = 'production' | 'batch';

// Read at call time so the screen and Header share the active card hierarchy.
export function getReviewSource(): ReviewSource {
  return featureFlags.useProductionsCardsDocumentDiscovery ? 'production' : 'batch';
}
